"use strict";
import { logger } from "utilities/src/logger/logger";
import { analytics } from "utilities/src/telemetry/analytics/analytics";
export function sendAnalyticsEvent(...args) {
  const [eventName, eventProperties] = args;
  analytics.sendEvent(eventName, eventProperties);
}
export async function sendAppsFlyerEvent(...args) {
  logger.warn("telemetry/index.web.ts", "sendWalletAppsFlyerEvent", "method not supported", args);
}
